.filetree {
  text-align: left;
  list-style-type: none;
  font-family: Arial, Helvetica, sans-serif
}
.filetree > li {
}
.directoryname {

}

.directoryname::after {
  content: "/";
}
.filename.ready {}
.filename.inqueue {}
.filename.inqueue::before {
  content: " \1F551";
  padding-right: .7em;
}
.filename.done {
  color: green;
}
.filename.done::before {
  content: " \2705";
  padding-right: .7em;
}
.filename.warning {
  color: orange;
  .force_queue {
    display: inline;
  }
}
.filename.warning::before {
  content: " \26A0";
  padding-right: .7em;
}
.filename.warning::after {
  content: " \2013  warning: " var(--warning-message);
}
.filename.converting {
  --convert-time-text: "";
  width: 100%;
}
.filename.converting::before {
  display: inline-block;
  text-align: center;
  content: var(--convert-progress-text) " " var(--convert-time-text);
  font-variant: tabular-nums;
  margin-right: 1em;
  width: 15em;
  box-sizing: border-box;
  border: 1px solid black;
  background-image: linear-gradient(to right,
    hsl(240, 70%, 50%, 20%) 50%,
    transparent 50%);
  background-size: 200%;
  background-position-x: calc(100% - 100% * var(--convert-progress));
}
.filename.error {
  color: red;
}
.filename.error::before {
  content: " \274C";
  padding-right: .7em;
}
.filename.error::after {
  content: " \2013  error: " var(--error-message);
}

.leaf {
  display: grid;
  grid: 1fr / 1fr auto;
  margin-right: 1em;
  align-items: center;
  &:hover {
    background-color: hsl(240, 100%, 50%, 10%);
  }
  .buttons {
    display: flex;
    gap: .3em;
  }
}

